import { render, staticRenderFns } from "./ResultInicisAuthPop.vue?vue&type=template&id=5bd037c8&scoped=true&"
import script from "./ResultInicisAuthPop.vue?vue&type=script&lang=js&"
export * from "./ResultInicisAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd037c8",
  null
  
)

export default component.exports